<!-- Error handling -->
<div ng-show="vm.saved === false" class="alert alert-danger spacer-top spacer-bottom">
  <h3>
    <p><i class="fa fa-warning"></i> Die Konsultation konnte nicht gespeichert werden,
      der Fehler wurde protokolliert!</p>
    <p><span class="btn btn-success" ng-click="vm.save()">Erneut probieren</span></p>
  </h3>
</div>

<!-- Header, function buttons -->
<div class="row">
  <div class="col-xs-12 col-md-4">
    <h3><span class="btn" ng-class="{'btn-info': !vm.consult.stared}" uib-tooltip="Besonders erinnerungswürdige Konsultation" ng-click="vm.togglestar()">
            <i class="fa fa-star" ng-class="{'yellow': vm.consult.stared}"></i>
        </span>&nbsp;Aktuelle Konsultation</h3>
  </div>
  <div class="col-xs-12 col-md-8" style="text-align: right">
        <span>
            <form class="form-inline" role="form">
                <div class="row">
                <div class="col-xs-12">
                    <h3>
                    <!-- Get media -->
                      <!-- Empfänger -->
                            <span class="input-group">
                                <span class="input-group-addon" uib-tooltip="Befundempfänger wählen">
                                        <i class="fa fa-envelope"></i></i>
                                </span>
                                <select ng-model="vm.consult.recipient" class="form-control" ng-change="vm.save()">
                                    <option value="patient">Patient</option>
                                    <option value="practdoctor"
                                            ng-show="vm.patient.svdata.practdoctor">Hausarzt</option>
                                    <option value="refdoctor"
                                            ng-show="vm.patient.svdata.refdoctor">Überweisender Arzt</option>
                                </select>

                            </span>
                      <!-- Rechnungspositionen und Finish -->
                        <button class="btn btn-warning"
                                ng-click="vm.closeConsultModal(vm.consult, vm.patient.diagnoses, vm.patient.test, vm.finish)">
                            <i class="fa fa-cart-plus" uib-tooltip="Rechnungsposition hinzuf&uuml;gen"></i><cartcounter
                            clientid="vm.consult.patientid"></cartcounter><i class="fa fa-sign-out" uib-tooltip="Rechnung &amp; Abschluß"></i>
                        </button>
<!--                      &lt;!&ndash; Rechnungspositionen &ndash;&gt;
                        <button class="btn btn-primary"
                                ng-click="vm.editCart(vm.consult.patientid, vm.patient.diagnoses, vm.patient.test)">
                            <i class="fa fa-cart-plus" uib-tooltip="Rechnungsposition hinzuf&uuml;gen"></i><cartcounter
                          clientid="vm.consult.patientid"></cartcounter>
                        </button>
                      &lt;!&ndash; Finish &ndash;&gt;
                        <button class="btn btn-warning" uib-tooltip="Rechnung &amp; Abschluß"
                                ng-click="vm.closeConsultModal(vm.consult, vm.patient.diagnoses, vm.patient.test, vm.finish)">
                            <i class="fa fa-sign-out"></i>
                        </button>-->
                      <!-- Imagecapture -->
                        <imagecapture captureid="cconsultphoto" consultid="vm.consultid"
                                      clientid="vm.consult.patientid"
                                      filecat="consultphoto"
                                      label="" color="info"></imagecapture>
                      <!-- Fileupload -->
                        <fileupload consultid="vm.consultid" clientid="vm.consult.patientid" label=""
                                    color="info"></fileupload>
                      <!-- Ueberweisung-->
                        <button class="btn btn-primary" uib-tooltip="Überweisung anlegen"
                                ng-click="vm.addReferralModal(vm.consult._id, vm.consult.patientid)">
                            <i class="fa fa-plus"></i> <i class="fa fa-user-md"> <refcounter
                          consultid="vm.consult._id"></refcounter></i>
                        </button>
                      <!-- Hilfsmittel-->
                        <button class="btn btn-primary" uib-tooltip="Hilfsmittel verordnen"
                                ng-click="vm.addAideModal(vm.consult._id, vm.consult.patientid)">
                            <i class="fa fa-plus"></i> <i class="fa fa-wheelchair"><aidecounter
                          consultid="vm.consult._id"></aidecounter></i>
                        </button>
                    </h3>
                </div>
                </div>
            </form>
        </span>
  </div>
</div>

<!-- Consult Keywords, do call consult.save() directly as keywords are bi-dirctionally bound -->
<consultkeywords keywords="vm.consult.keywords" parentsave="vm.save()"></consultkeywords>

<!-- Consult main fields -->
<form>
  <!-- Consult Findings data upper row (Symptome, Therapie) -->
  <div class="row">
    <!-- Symptome -->
    <div class="col-xs-12 col-sm-6">
      <div class="form-group">
        <div class="form-group">
          <h4>Symptome
            <sprhelp tip="Symptome und Annamnese" descref="vm.sprsymptoms" file="befundvorlagen.pdf"
                     video="befundvorlagen"></sprhelp>
            <span class="btn btn-xs">&nbsp;</span></h4>
          <vcarea model="vm.consult.symptoms"
                  parentsave="vm.childsave(key, value)"
                  id="symptoms"
                  options="{ updateOn: 'default blur', debounce: { default: 20000, blur: 0 } }">
          </vcarea>


        </div>
      </div>
    </div>
    <!-- Therapie -->
    <div class="col-xs-12 col-sm-6">
      <div class="form-group">
        <h4><span class="pull-left">Therapieempfehlung <sprhelp tip="Allgemeine Therapievorschläge"
                                                                descref="vm.sprtherapy"></sprhelp> </span>
          <span class="pull-right">
                            <currentexamstherapies consultid="vm.consultid"></currentexamstherapies>
            <!--<span class="btn btn-success btn-xs"><i class="fa fa-list-ul"></i> </span>-->
                        </span>
          <span class="clearfix"></span>
        </h4>

        <vcarea model="vm.consult.therapy"
                parentsave="vm.childsave(key, value)"
                id="therapy"
                options="{ updateOn: 'default blur', debounce: { default: 20000, blur: 0 } }">
        </vcarea>
      </div>
    </div>
  </div>

  <!-- Consult Findings data lower row (Anmerkungen, Notizen) -->
  <div class="row">
    <!-- Befund -->
    <div class="col-xs-12 col-sm-6">
      <div class="form-group">

        <!--uib-tooltip="Ergänzung zu Detailbefunden der einzelnen Untersuchungen"-->
        <h4>
                    <span class="pull-left">Gesamtbefund<sprhelp tip="Befundzusammenfassungen"
                                                                 descref="vm.sprfindings"></sprhelp></span>
          <span class="pull-right">
                        <currentexamsfindings consultid="vm.consultid"></currentexamsfindings>
                        <currentexamscomments consultid="vm.consultid"></currentexamscomments>
                        <a class="btn btn-info btn-xs" href="{{vm.consultPreviewUrl(vm.consult._id)}}" target="_blank"
                           uib-tooltip="PDF Vorschau">
                            <i class="fa fa-eye"></i>
                        </a>
                    </span>
          <span class="clearfix"></span>
        </h4>
        <vcarea model="vm.consult.findings"
                parentsave="vm.childsave(key, value)"
                id="findings"
                options="{ updateOn: 'default blur', debounce: { default: 20000, blur: 0 } }">
        </vcarea>
      </div>
    </div>
    <div class="col-xs-12 col-sm-6">
      <!-- Patientennotizen -->
      <div class="form-group">
        <!--uib-tooltip="Diese Patientennotizen werden nicht in Befunde oder andere Dokumente übernommen."-->
        <h4>
          Permanente Notizen zum Patienten (privat)
          <sprhelp tip="Private Notizen" descref="vm.sprnotes"></sprhelp>
          <span class="btn btn-xs">&nbsp;</span></h4>
        <clientnotes clientid="vm.consult.patientid" mode="patient" id="consultnotes"></clientnotes>

      </div>
    </div>
  </div>

  <!-- show imges -->
  <consultimagelist consultid="vm.consultid"></consultimagelist>


  <!-- show files -->
  <consultfilelist consultid="vm.consultid"></consultfilelist>

  <!-- Untersuchungsstarter (keine offene Untersuchung) -->
  <examstarter consult="vm.consult"></examstarter>

  <!-- Aktuelle Untersuchungen -->
  <currentexams consultid="vm.consultid"></currentexams>

</form>

